import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface CheckboardCache {
  [key: string]: string | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Checkboard',
  props: {
    size: { default: 8 },
    white: { default: '#fff' },
    grey: { default: '#e6e6e6' }
  },
  setup(__props: any) {

const props = __props

const checkboardCache: CheckboardCache = {}

const renderCheckboard = (white: string, grey: string, size: number) => {
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = size * 2
  const ctx = canvas.getContext('2d')
  
  if (!ctx) return null

  ctx.fillStyle = white
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.fillStyle = grey
  ctx.fillRect(0, 0, size, size)
  ctx.translate(size, size)
  ctx.fillRect(0, 0, size, size)
  return canvas.toDataURL()
}

const getCheckboard = (white: string, grey: string, size: number) => {
  const key = white + ',' + grey + ',' + size
  if (checkboardCache[key]) return checkboardCache[key]
  
  const checkboard = renderCheckboard(white, grey, size)
  checkboardCache[key] = checkboard
  return checkboard
}

const bgStyle = computed(() => {
  const checkboard = getCheckboard(props.white, props.grey, props.size)
  return { backgroundImage: `url(${checkboard})` }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "checkerboard",
    style: _normalizeStyle(bgStyle.value)
  }, null, 4))
}
}

})